<template>
  <!-- style="padding-bottom: 2.4rem" -->
  <div class="default-page">
    <div class="swiper-container" ref="swiperContainer">
      <div class="swiper-container-box">
        <scroll-list :scroll-list="bannerImgs" @afterLoaded="afterLoadedScroll"></scroll-list>
      </div>
    </div>
    <div>
      <nuxt />
    </div>
  </div>
</template>

<script>
import ScrollList from '~/components/ScrollList.vue'
import axios from '~/plugins/axios'

export default {
  data () {
    return {
      bannerImgs: []
    }
  },
  async mounted () {
    // let bannerImg = await axios.get('https://ban.zhoubao.me/api/discovery/getBannerList?key=zeroPlusBanner')
    // bannerImg = bannerImg.data;
    // let bannerImgList = []
    // if (bannerImg && bannerImg.data && bannerImg.code == 200 && bannerImg.data.bannerList) {
    //   bannerImg.data.bannerList.forEach(item => {
    //     //链接类型 1，群 2，币用链接 3，外链 4，第三方应用 ，5,详情文章
    //     if (item.linkType === 1) {
    //       item.linkUrl = 'https://ss.transgot.cn/' + item["linkUrl"]
    //     }
    //     bannerImgList.push({
    //       imgUrl: item.cover,
    //       linkUrl: item.linkUrl,
    //       banner: item
    //     })
    //   })
    // }
    // this.bannerImgs = bannerImgList
  },
  components: {
    ScrollList
  },
  methods: {
    afterLoadedScroll () {
      $(this.$refs.swiperContainer).css('height', 'auto')
    }
  }
}
</script>

<style lang="scss">
.swiper-container {
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  width: 100%;
  max-height: 2rem;
  border-radius: 6px;
  overflow: hidden;
  transform: rotate(0deg);
  &-box {
    max-height: 2rem;
    width: 100%;
    margin: 0 auto;
    height: 100%;
  }
  .swiper-pagination-bullet {
    opacity: 1;
    background: rgba(255, 255, 255, 0.5);
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
    background: #fff;
  }
}

.main-banner {
  img {
    width: 100%;
    height: 100%;
  }
}
@media screen and (min-width: 800px) {
  .swiper-container {
    &-box {
      height: 2rem;
      max-width: 8rem;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// layouts/default.vue